module.exports = __webpack_public_path__ + "static/media/trash.01f7dfb5.svg";